<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm" class="reset-form-inline">
          <el-form-item label="状态">
            <template slot="label">
              <I18Lang id="proxymoney5" defaultText="状态" />
            </template>
            <el-select v-model="queryForm.auth_status" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in statusList" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="代理ID/上级代理ID">
            <template slot="label">
              <I18Lang id="proxymoney9" defaultText="代理ID/上级代理ID" />
            </template>
            <el-input :placeholder="$t('my134')" v-model="queryForm.account_id"></el-input>
          </el-form-item>

          <el-form-item label="出金时间">
            <template slot="label">
              <I18Lang id="my108" defaultText="出金时间" />
            </template>
            <el-date-picker v-model="openDate" type="daterange" @change="openDateChange" value-format="yyyy-MM-dd"
              range-separator="-" :start-placeholder="$t('public22')" :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>

        </el-form>
        <div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </div>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="my66" defaultText="流水号" />
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot="header">
              <I18Lang id="proxyproxy10" defaultText="姓名" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.user.username }}
            </template>
          </el-table-column>
          <el-table-column width="120" label="代理ID">
            <template slot="header">
              <I18Lang id="proxyproxy22" defaultText="代理ID" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.user.account_id }}
            </template>
          </el-table-column>
          <el-table-column width="120" label="主代理ID" prop="master_agent_id">
            <template slot="header">
              <I18Lang id="proxyproxy23" defaultText="上级代理ID" />
            </template>
            <template slot-scope="{row}" v-if="row.parent_user">
              {{ row.parent_user.account_id }}
            </template>
          </el-table-column>

          <el-table-column width="120" label="出金金额($)" prop="amount_usd">
            <template slot="header">
              <I18Lang id="proxymoney53" defaultText="出金金额($)" />
            </template>
          </el-table-column>

          <el-table-column width="120" label="出金汇率" prop="exchange_rate">
            <template slot="header">
              <I18Lang id="proxymoney54" defaultText="出金汇率" />
            </template>
          </el-table-column>

          <el-table-column width="190" :label="$t('proxymoney201')" prop="amount_local">
          </el-table-column>

          <el-table-column width="180" label="操作后账户余额(MEQ)">
            <template slot="header">
              <I18Lang id="recordAfterBalance" defaultText="操作后账户余额(MEQ)" />
            </template>
            <template slot-scope="scope">
              {{ formatAmount(scope.row.cash_balance) }}
            </template>
          </el-table-column>
          <el-table-column width="150" label="出金时间" prop="create_time">
            <template slot="header">
              <I18Lang id="proxymoney56" defaultText="出金时间" />
            </template>
          </el-table-column>
          <el-table-column width="120" label="状态">
            <template slot="header">
              <I18Lang id="my95" defaultText="状态" />
            </template>
            <template slot-scope="scope">
              <StatusText :status="scope.row.auth_status" :text="statusList[scope.row.auth_status]" />
            </template>
          </el-table-column>
          <el-table-column width="150" label="操作">
            <template slot="header">
              <I18Lang id="my96" defaultText="操作" />
            </template>
            <template slot-scope="scope">
              <div class="operat-group">
                <span class="operat-item btn-auth" v-if="scope.row.auth_status === 1"
                  @click="operat(scope.row, 'audit')"></span>
                <span class="operat-item btn-query" @click="operat(scope.row, 'look')"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialog.operat"
      :title="dialogType === 'look' ? `${$t('my97')}（${currentData.stream_no}）` : `${$t('proxymoney27')}（${currentData.stream_no}）`"
      width="30%" :close-on-click-modal="false" :close-on-press-escape="false" class="info-dialog">
      <div v-loading="isSubmitLoading">
        <el-descriptions :colon="false" class="descriptions-info" :column="1">
          <el-descriptions-item label="姓名" v-if="currentData.user">
            <template slot="label">
              <I18Lang id="proxyproxy10" defaultText="姓名" />
            </template>{{ currentData.user.username }}
          </el-descriptions-item>
          <el-descriptions-item label="代理ID" v-if="currentData.user">
            <template slot="label">
              <I18Lang id="proxyproxy22" defaultText="代理ID" />
            </template>
            {{ currentData.user.account_id }}
          </el-descriptions-item>
          <el-descriptions-item label="出金金额(本地货币)">
            <template slot="label">
              <I18Lang id="proxymoney201" defaultText="出金金额（本地货币）" />
            </template>
            {{ currentData.amount_local }}
          </el-descriptions-item>
          <el-descriptions-item label="出金金额($)">
            <template slot="label">
              <I18Lang id="proxymoney53" defaultText="出金金额($)" />
            </template>
            {{ currentData.amount_usd }}
          </el-descriptions-item>
          <el-descriptions-item label="出金时间">
            <template slot="label">
              <I18Lang id="proxymoney56" defaultText="出金时间" />
            </template>
            {{ currentData.create_time }}
          </el-descriptions-item>
          <el-descriptions-item label="出金汇率">
            <template slot="label">
              <I18Lang id="public81" defaultText="出金汇率" />
            </template>
            {{ currentData.exchange_rate }}
          </el-descriptions-item>

          <el-descriptions-item labelClassName="bank-descriptions-item" label="">
              <template slot="label">
                <div class="bank-info">
                  <p>
                    <I18Lang id="text60" defaultText="钱包类型" />
                    {{ currentData.wallet_type }}
                  </p>
                  <p>
                    <I18Lang id="text59" defaultText="钱包地址" />
                    {{ currentData.wallet_address }}
                  </p>
                </div>
              </template>
          </el-descriptions-item>

          <template v-if="dialogType === 'audit'">

            <el-descriptions-item label="审批">
              <template slot="label">
                <I18Lang id="proxycust35" defaultText="审批" />
              </template>
              <el-radio-group v-model="form.auth_status">
                <el-radio :label="2">
                  <I18Lang id="proxycust37" defaultText="通过" />
                </el-radio>
                <el-radio :label="3">
                  <I18Lang id="proxycust38" defaultText="不通过" />
                </el-radio>
              </el-radio-group>
            </el-descriptions-item>
          </template>
          <template v-if="dialogType !== 'audit'">
            <el-descriptions-item label="审批备注">
              <template slot="label">
                <I18Lang id="my94" defaultText="审批备注" />
              </template>
              {{ currentData.auth_remark }}
            </el-descriptions-item>
            <el-descriptions-item label="审批状态">
              <template slot="label">
                <I18Lang id="proxymoney33" defaultText="审批状态" />
              </template>
              {{ statusList[currentData.auth_status] }}
            </el-descriptions-item>
          </template>

        </el-descriptions>
        <template v-if="dialogType === 'audit'">
          <div v-if="form.auth_status === 3">
            <el-input type="textarea" class="reset-input audit-input" v-model="form.auth_remark"
              placeholder="Please enter your approval opinions"></el-input>
          </div>
        </template>
        <div class="dialog-footer mt">
          <div class="kg-btn2" @click="dialog.operat = false">
            <I18Lang id="my58" v-if="dialogType === 'audit'" defaultText="取消" />
            <I18Lang id="my25" defaultText="确定" v-else />
          </div>
          <template v-if="dialogType === 'audit'">
            <div class="kg-btn2" type="primary" @click="onAudit">
              <I18Lang id="my25" defaultText="确定" />
            </div>
          </template>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import { mapState } from 'vuex'
import { auditStatusList } from '@utils/global'
import StatusText from '@/components/StatusText'
export default {
  name: 'record',
  data () {
    return {
      openDate: '',
      closeDate: '',
      dialog: {
        operat: false
      },
      isSubmitLoading: false,
      dialogType: '',
      form: {
        id: '',
        auth_status: 2,
        auth_remark: ''
      },
      queryForm: {
        auth_status: '',
        account_id: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 10,
        is_agent: 1
      },
      statusList: auditStatusList,
      currentData: {},
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  created () {
    this.getRecord()
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  methods: {
    formatAmount (value) {
      const amount = Number(value)
      return Number.isFinite(amount) ? amount.toFixed(2) : '-'
    },
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/withdrawalRecords?${formateObjToParamStr(
          params
        )}`
      )
    },
    getRecord () {
      this.$http.post('/api/agent/withdrawalRecords', this.queryForm).then(result => {
        this.tableData = result
      })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryDate = ''
      this.pageChange(1)
    },
    openDateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    closeDateChange (val) {
      this.queryForm.close_start_date = val ? val[0] : ''
      this.queryForm.close_end_date = val ? val[1] : ''
    },
    operat (item, type) { // 查看凭证
      this.dialog.operat = true
      this.dialogType = type
      this.currentData = item
      this.form.id = item.id
    },
    onAudit () {
      this.isSubmitLoading = true
      this.$http.post('/api/agent/authWithdrawal', this.form).then(result => {
        this.getRecord()
        this.dialog.operat = false
      }).finally(() => {
        this.isSubmitLoading = false
      })
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  },
  components: {
    StatusText
  }
}
</script>
<style scoped lang="scss">
::v-deep .bank-descriptions-item {
  width: 100%;
  flex: 0 0 100%;

  .el-descriptions-item__content {
    display: none;
  }
}

.bank-info {
  width: 100%;

  p {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
}
</style>
